import React from "react";
import { withStyles } from "@material-ui/styles";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "./CloseIcon";

import { error, success } from "../../constants/common";

import images from "../../assets/img/images";

const styles = {
  dialogPaper: {
    padding: "12px",
    minWidth: "400px",
    maxWidth: "400px",
  },
  closeIconItem: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
};

const CreateCompanies = (props) => {
  const { classes, status, onClose } = props;

  return (
    <Dialog open={true} classes={{ paper: classes.dialogPaper }}>
      <Grid container direction="column">
        <Grid item className={classes.closeIconItem}>
          <CloseIcon closeFunction={onClose} />
        </Grid>
        <Grid item className="text-center">
          <img
            src={
              status === success
                ? images.greenCheckmarkWhite
                : status === error
                ? images.errorIcon
                : ""
            }
            width="50px"
            alt="status"
            style={{ display: "inline-block" }}
          />
        </Grid>
        <Grid item style={{ padding: "24px" }}>
          {props.children}
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default withStyles(styles)(CreateCompanies);
